import BaseController from './base_controller'

export default class FavoritePortfolioButtonController extends BaseController {
  // Update the data-portfolio-tab-data-fetch-fetch-data-flag-value on Portfolio#index favorite's tab
  // So the Favorite table will refresh after clicking the favorites tab
  refreshFavoriteTab () {
    Cog.portfolioTabDataFetchControllers.favorite_portfolios.updateCurrent(true)
  }
}
